import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import * as styles from './AuthorizationButton.scss';

class AuthorizationButton extends React.Component {
  render() {
    const { isLoading, disabled, onClick, className, children } = this.props;
    return (
      <button
        className={cx(styles.authorizationButton, 'btn btn-primary', className)}
        onClick={onClick}
        disabled={disabled || isLoading}
      >
        {isLoading ? (
          <i className="icon icon-om-spinner om-pulse" />
        ) : (
          <span className="button-text">
            {children}
          </span>
        )}
      </button>
    );
  }
}

AuthorizationButton.propTypes = {
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.any,
  onClick: PropTypes.func,
  className: PropTypes.string
};

export default AuthorizationButton;
